import React from 'react';


import Thumbnail from './Thumbnail';

class FilterList extends React.Component {
    constructor(){
        super()
        this.state ={
            filterButtons: [],
            cleanedData: [],
            filteredArr: [],
        }
        this.fiterButton = this.fiterButton.bind(this);

    }

    
    componentDidUpdate(prevProps,prevState) {
        if(prevProps.cleanedData !== this.props.cleanedData){
            var data = this.props.cleanedData
            var labelArray = [].concat.apply(["all"],data.map(data=>data.label));
            var uniqueLabelArray = Array.from(new Set(labelArray));
            // var testArr;
            // testArr =uniqueLabelArray.map(item=>{ return {"label": item, "active": false}} )
            this.setState({
                cleanedData: data,
                filterButtons: uniqueLabelArray.concat(uniqueLabelArray.sort().splice(uniqueLabelArray.indexOf('other'), 1)[0]), 
                filteredArr: data
            })
        }
    }

    componentDidMount(){
        this.setState({
            filteredArr: this.state.cleanedData
        })
          
    }

    fiterButton(e){
        e.preventDefault();
        this.props.handleClick();

        var initialData = this.state.cleanedData
        // console.log(initialData)

        var filteredArr = [];
        // console.log(e.target.value)
        if(e.target.value === "all"){
            filteredArr = initialData
        }else{
            filteredArr = initialData.filter(data=> data.label === e.target.value);
            
        }
        this.setState({
            filteredArr: filteredArr,
        })
        // console.log('currentdataArr in one post: ', filteredArr,filteredArr.length)
    }
  
    render(){
        const {filterButtons,filteredArr} =this.state;
       return (
        <div>
            <div className="filterbuttonbox">
            <span className="filterbuttonbox--title">Posts</span>
            <div className="filterbuttonbox--buttongroup">
            {filterButtons.map((list, index)=>
                (<button 
                    value={list} 
                     onClick={this.fiterButton} 
                     key={index} 
                     className="filterbuttonbox--buttongroup---filterbutton">{list}
                     </button>))
            }
            </div>
            </div>
            <Thumbnail 
            filteredData={filteredArr} />
        </div>
       );
    }
}

export default FilterList;